import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';

import axios from "src/app/Service/axios";

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { NotificationService } from 'src/app/Service/notification.service';

import { OtherService } from 'src/app/Service/other.service';

import { animate, state, style, transition, trigger } from '@angular/animations';

import * as XLSX from 'xlsx';

declare let $: any;

@Component({

  selector: 'app-service-fee',

  templateUrl: './service-fee.component.html',

  styleUrls: ['./service-fee.component.css'],

  animations: [

    trigger('fadeAnimation', [

      state('void', style({ opacity: 0 })),

      transition(':enter', [

        animate('300ms ease-in', style({ opacity: 1 }))

      ]),

      transition(':leave', [

        animate('100ms ease-out', style({ opacity: 0 }))

      ])

    ])

  ]

})

export class ServiceFeeComponent implements OnInit {

  searchT_City = '';

  filteredCity: any = [];

  list_City: any[] = [];

  list_Search: any[] = [];

  list_Search2: any[] = [];

  list_Result: any[] = [];

  list_CarsFeeBaseType: any[] = [];

  list_CarType: any[] = [];

  editMode: boolean = false;

  addMode: boolean = false;

  bCarResult: boolean = true;

  bShowFilter: boolean = false;

  sourceModel: FormGroup = this.FormBuilder.group({

    iYear: new FormControl('', Validators.required),

    strCity: new FormControl('', Validators.required),

    fCompanyPercent: new FormControl(1, [Validators.required]),

    fMuncPercent: new FormControl('', Validators.required),

    fInsurancePercent: new FormControl('', Validators.required),

    fEducationPercent: new FormControl('', Validators.required),

    iSchool_ServiceFee: new FormControl('initialValue', Validators.required),

    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

  })

  feeBaseCar: FormGroup = this.FormBuilder.group({

    iSchool_ServiceFee: new FormControl('', Validators.required),

    iSchool_ServiceFeeGPSType: new FormControl(''),

    tiMobileType: new FormControl('', Validators.required),

    iBaseCost: new FormControl('', Validators.required),

    tiMinKM: new FormControl('', Validators.required),

    iCostPerKM: new FormControl('', Validators.required),

    iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

  })

  constructor(private otherService: OtherService, private FormBuilder: FormBuilder, private ActivatedRoute: ActivatedRoute, private router: Router, private gurdService: GurdServiceService, private Notification: NotificationService) { }

  ngOnInit(): void {

    this.getListCity()

  }

  filterCity() {

    if (this.searchT_City == '') {

      this.filteredCity = [];

      this.sourceModel.controls['strCity'].setValue('')

    }

    else this.filteredCity = this.list_City.filter((item: any) => item.strCityName.includes(this.searchT_City));

  }

  getListCity = async () => {

    this.otherService.Showspinner()

    let res = JSON.parse((await axios.post(`City_List`, this.sourceModel.value)).data.toString());

    this.otherService.nonespinner()

    this.list_City = res;

    this.list_Search = res;

  }

  selectedCity(item: any) {

    this.sourceModel.controls['strCity'].setValue(item.strCity)

    this.searchT_City = item.strCityName;

    this.filteredCity = [];

  }

  hideCity_Option() {

    setTimeout(() => {

      this.filteredCity = [];

    }, 300);
  }

  searchBy(search: any, target?: string) {

    if (!target) {

      if (search.length > 2) {

        this.list_Result = this.list_Search.filter((el: any) => {

          return el.strCityName.includes(search) || el.iYear.toString().includes(search)

        })
      }

      else if (search == '') this.list_Result = this.list_Search

    }

    else {

      if (search.length > 2) {

        this.list_CarsFeeBaseType = this.list_Search2.filter((el: any) => {

          return el.strGPSType_strComment.includes(search)

        })
      }

      else if (search == '') this.list_CarsFeeBaseType = this.list_Search2

    }
  }

  searchFee = async () => {

    if (this.sourceModel.value.iYear.length < 4 || this.sourceModel.value.strCity == '') return this.Notification.showError('لطفا فرم را با دقت تکمیل کنید');

    this.otherService.Showspinner()

    let res = JSON.parse((await axios.post('School_ServiceFee_List', this.sourceModel.value)).data.toString());

    this.otherService.nonespinner()

    if (!res.length) return this.Notification.showError(' موردی یافت نشد !!')

    this.list_Result = res;

    this.list_Search = res;


  }

  newService_Fee = async () => {

    if (this.sourceModel.invalid) return this.Notification.showError('لطفا فرم را با دقت تکمیل کنید');

    var model = this.sourceModel.value;

    model.fCompanyPercent = parseInt(model.fCompanyPercent)

    model.fMuncPercent = parseInt(model.fMuncPercent)

    model.fInsurancePercent = parseInt(model.fInsurancePercent)

    model.fEducationPercent = parseInt(model.fEducationPercent)

    // if (Object.values(model).some(val => !val)) return this.Notification.showError('لطفا فرم را با دقت تکمیل کنید');

    if (!this.editMode) {

      this.otherService.Showspinner()

      let res = JSON.parse((await axios.post('School_ServiceFee_Save', model)).data.toString());

      this.otherService.nonespinner()

      if (res.iResult == 0) return this.Notification.showError(res.strError);

      this.addMode = false;

      $(`#service_Fee`).modal('hide');

      return this.Notification.showSuccess('با موفقیت اضافه شد');
    }

    else {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              this.otherService.Showspinner()

              let res = JSON.parse((await axios.post('School_ServiceFee_Edit', model)).data.toString());

              this.otherService.nonespinner();

              if (res.iResult == 0) return this.Notification.showError(res.strError);

              $(`#service_Fee`).modal('hide');

              const index = this.list_Result.indexOf(model);

              if (index != -1) this.list_Result[index] = res;

              this.editMode = false;

              this.Notification.showSuccess('با موفقیت ویرایش شد');

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

  }

  removeFee = async (item: any) => {

    $.confirm({

      title: `آیا از حذف این تعرفه اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            var model = {

              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              iSchool_ServiceFee: item.iSchool_ServiceFee,

              iSchool_ServiceFeeGPSType: item?.iSchool_ServiceFeeGPSType ? item.iSchool_ServiceFeeGPSType : '',

            };

            this.otherService.Showspinner();

            let url = item?.iSchool_ServiceFeeGPSType ? 'School_ServiceFeeGPSType_Delete' : 'School_ServiceFee_Delete'

            let res = JSON.parse((await axios.post(url, model)).data.toString());

            this.otherService.nonespinner();

            if (res.iResult == 0) return this.Notification.showError(res.strError);

            else {

              if (url == 'School_ServiceFeeGPSType_Delete') {

                const index = this.list_CarsFeeBaseType.indexOf(item);

                if (index != -1) this.list_CarsFeeBaseType.splice(index, 1);

                this.Notification.showSuccess('تعرفه با موفقیت حذف شد');

              }

              else {

                const index = this.list_Result.indexOf(item);

                if (index != -1) this.list_Result.splice(index, 1);

                this.Notification.showSuccess('تعرفه با موفقیت حذف شد');


              }

            }

          }

        },

        cancel: {

          text: "لغو",


        }

      }

    });

  }

  addNewFeeBaseCar = async () => {

    if (this.feeBaseCar.invalid) return this.Notification.showError('لطفا فرم را با دقت تکمیل کنید');

    if (!this.editMode) {

      this.otherService.Showspinner()

      let res = JSON.parse((await axios.post('School_ServiceFeeGPSType_Save', this.feeBaseCar.value)).data.toString());

      this.otherService.nonespinner()

      if (res.iResult == 0) return this.Notification.showError(res.strError);

      this.list_CarsFeeBaseType.push(res[0])

      this.bCarResult = true

      return this.Notification.showSuccess('با موفقیت اضافه شد');

    }

    else {

      $.confirm({

        title: `آیا از ویرایش اطلاعات تعرفه نوع خودرو اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              this.otherService.Showspinner()

              let res = JSON.parse((await axios.post('School_ServiceFeeGPSType_Edit', this.feeBaseCar.value)).data.toString());

              this.otherService.nonespinner()

              if (res.iResult == 0) return this.Notification.showError(res.strError)

              await this.getFeeBaseSpecificCar({ iSchool_ServiceFee: this.feeBaseCar.value.iSchool_ServiceFee })

              this.editMode = false;

              this.bCarResult = true;

              this.Notification.showSuccess('با موفقیت ویرایش شد');

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

  }

  editFeeBaseCar(item: any) {

    this.editMode = true;

    this.bCarResult = false;

    Object.keys(item).forEach(key => {

      this.feeBaseCar.get(key)?.setValue(item[key])

    })

  }

  openModal = async (item?: any, id?: string) => {

    this.bShowFilter = false; 

    setTimeout(() => {

      this.bShowFilter = true; 

    }, 10);

    if (!id) {

      if (!item) {

        this.addMode = true;

        this.searchT_City = '';

        this.sourceModel.patchValue({

          iYear: '',

          strCity: '',

          fCompanyPercent: '',

          fMuncPercent: '',

          fInsurancePercent: '',

          fEducationPercent: '',

        })

      }

      else {

        this.editMode = true;

        this.searchT_City = item.strCityName;

        Object.keys(item).forEach(key => {

          this.sourceModel.get(key)?.setValue(item[key])

        })


      }

      $(`#service_Fee`).modal('show');

    }

    else {

      await this.getFeeBaseSpecificCar(item)

      $(`#${id}`).modal('show');

    }

  }

  getFeeBaseSpecificCar = async (item: any) => {

    var model = {

      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      iSchool_ServiceFee: item.iSchool_ServiceFee,

    };

    this.otherService.Showspinner();

    let res = JSON.parse((await axios.post('School_ServiceFeeGPSType_List', model)).data.toString());

    let resp = await axios.post(`GetMobileType`);

    this.list_CarsFeeBaseType = res;

    this.list_Search2 = res;

    this.list_CarType = resp.data;

    this.feeBaseCar.controls['iSchool_ServiceFee'].setValue(item.iSchool_ServiceFee)

    this.otherService.nonespinner();
  }

  initAddMde() {

    this.feeBaseCar.patchValue({

      iSchool_ServiceFeeGPSType: (''),

      tiGPSType: (''),

      iBaseCost: (''),

      tiMinKM: (''),

      iCostPerKM: (''),

    })

    this.editMode = false;

    this.bCarResult = false

  }

  exportExcel() {

    setTimeout(() => {

      let element = document.getElementById('Export_Excel');

      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, 'تعرفه سرویس مدرسه.xlsx');

    }, 200);

  }

  trackByType(index: number, item: any) {

    return item.iSchool_ServiceFeeGPSType
  }

  closeFeeModal() {

    this.searchT_City = this.list_Result[0].strCityName;

    this.sourceModel.controls['strCity'].setValue(this.list_Result[0].strCity);

    this.sourceModel.controls['iYear'].setValue(this.list_Result[0].iYear);

    this.editMode = false;

    this.addMode = false;

  }

  goBack() {

    this.router.navigate(['/'])

  }


}
